import { useState } from 'react';
import { MessageSquare } from 'lucide-react';

interface FloatingFeedbackProps {
  onSend?: (text: string) => void;
}

export function FloatingFeedback({ onSend }: FloatingFeedbackProps) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [sent, setSent] = useState(false);

  const handleSend = () => {
    if (!text.trim()) return;
    onSend?.(text.trim());
    setText('');
    setOpen(false);
    setSent(true);
    setTimeout(() => setSent(false), 2500);
  };

  return (
    <>
      {/* Panel */}
      {open && (
        <div className="fixed bottom-[72px] right-6 bg-proposal-bg2 border border-proposal-border-strong rounded-p-lg p-5 w-[280px] z-[99] shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
          <div className="text-sm font-semibold text-proposal-fg1 mb-3">¿Algún comentario?</div>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Escribe tu feedback aquí..."
            rows={4}
            className="w-full bg-proposal-bg border border-proposal-border-strong rounded-p-md p-2.5 text-[13px] text-proposal-fg1 font-proposal-ui resize-y min-h-[80px] outline-none transition-colors focus:border-proposal-accent"
          />
          <button
            onClick={handleSend}
            className="w-full bg-proposal-accent text-proposal-accent-text border-none rounded-p-md py-2 text-[13px] font-semibold cursor-pointer mt-2.5 font-proposal-ui transition-opacity hover:opacity-85"
          >
            Enviar
          </button>
        </div>
      )}

      {/* Button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 bg-proposal-accent text-proposal-accent-text border-none rounded-full px-4.5 py-2.5 text-[13px] font-semibold cursor-pointer z-[99] flex items-center gap-1.5 transition-all hover:opacity-90 hover:-translate-y-px font-proposal-ui shadow-[0_4px_20px_rgba(182,255,60,0.3)]"
      >
        <MessageSquare size={14} />
        {sent ? '✓ Enviado' : 'Feedback'}
      </button>
    </>
  );
}
